import React from 'react'
import EContentList from 'src/modules/EContent/List'

const EContentListPage = () => {
  return <EContentList />
}

export default EContentListPage
